import React from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { _api_get_equipments } from "../api";
import { ROUTES } from "../../../constants/routes";
import { useSetStep } from "../stores/useStepNumber";
import { useUserOffboarding } from "./useUserOffboarding";

const useLogicStepEquipments = () => {
    // * HOOKS
    // * HOOKS
    // * HOOKS
    useSetStep(4); // on est a la 4eme étape
    const { user_offboarding } = useUserOffboarding();

    // * STATES
    // * STATES
    // * STATES
    const navigate = useNavigate();

    // * CONSTANTS
    const QUERY_KEY = "resources";

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    const { data: equipments = [], isLoading } = useQuery([QUERY_KEY], () =>
        _api_get_equipments({ id_user: user_offboarding.id })
    );

    // * FUNCTIONS
    // * FUNCTIONS
    // * FUNCTIONS
    const format_data_equipments = (equipments_to_format = []) => {
        return equipments_to_format?.map((equipment) => {
            const is_checked_every_childrens = equipment.resources.every(
                (res) => res.is_assigned
            );
            const is_checked_some_childrens = equipment.resources.some(
                (res) => res.is_assigned
            );
            return {
                ...equipment,
                checked: is_checked_every_childrens
                    ? true
                    : is_checked_some_childrens
                    ? "mixed"
                    : false,
                resources: equipment.resources.map((resource) => {
                    return {
                        ...resource,
                        checked: resource.is_assigned,
                    };
                }),
            };
        });
    };

    return {
        query: {
            data: equipments,
            isLoading,
            formated_data: equipments
                ? format_data_equipments(equipments)
                : null,
        },
        navigation: {
            buttonNextStep: () => {
                return navigate(
                    `${ROUTES.offboarding.prepare_offboarding}/attribute_tasks${location.search}`
                );
            },
            buttonBackStep: () => {
                return navigate(
                    `${ROUTES.offboarding.prepare_offboarding}/leave_balances${location.search}`
                );
            },
        },
    };
};

export default useLogicStepEquipments;
